// extracted by mini-css-extract-plugin
export default {"cartItem":"CartItem_cartItem__eAoxI","cartItemInfo":"CartItem_cartItemInfo__n4uoa"};